import react, { useState } from "react";
import { Box, alpha, Paper } from "@mui/material";
import { setSourceMapRange } from "typescript";
import muiTheme from "../../themes/muiTheme";

interface Props {
  viewerWidth: number;
  viewerHeigth: number;
  icon: string;
  isPortrait: boolean;
  leftPosition?: number;
  rightPosition?: number;
  setPage: () => void;
}

export const ViewerButton = ({
  viewerWidth,
  viewerHeigth,
  icon,
  isPortrait,
  setPage,
  leftPosition = undefined,
  rightPosition = undefined,
}: Props) => {
  const [isHover, setIsHover] = useState(false);
  return (
    <Paper onClick={setPage}>
      <Box
        height={viewerHeigth}
        position="absolute"
        left={
          leftPosition === undefined
            ? undefined
            : (leftPosition ?? 0) - viewerWidth
        }
        right={
          rightPosition === undefined
            ? undefined
            : (rightPosition ?? 0) - viewerWidth
        }
        sx={{
          position: "absolute",
          width: { lg: 72, xs: 24 },
        }}
        onMouseEnter={() => {
          if (!isPortrait) {
            setIsHover(true);
          }
        }}
        onMouseLeave={() => {
          if (!isPortrait) {
            setIsHover(false);
          }
        }}
      />
      <Box
        sx={{
          display: "flex",
          flex: 10,
          width: { lg: 80, xs: 24 },
          height: viewerHeigth,
          position: "absolute",
          left: { lg: leftPosition, xs: leftPosition && -12 },
          right: { lg: rightPosition, xs: rightPosition && -12 },
          alignItems: "center",
          justifyContent: "center",
        }}
        onMouseEnter={() => {
          if (!isPortrait) {
            setIsHover(true);
          }
        }}
        onMouseLeave={() => {
          if (!isPortrait) {
            setIsHover(false);
          }
        }}
      >
        <Box
          component="img"
          src={icon}
          borderRadius={1}
          sx={{
            display: "flex",
            justifyContent: "center",
            position: "absolute",
            width: 24,
            height: 24,
            py: { lg: 4.8, xs: 2.8 },
            px: { lg: 0.4, xs: 0 },
            bgcolor: isHover
              ? muiTheme.palette.alpha.blue80
              : muiTheme.palette.alpha.grey,
            "&:hover": {
              bgcolor: isPortrait ? null : muiTheme.palette.alpha.blue80,
            },

            "&:focus": {
              bgcolor: muiTheme.palette.alpha.blue80,
              color: muiTheme.palette.alpha.grey,
            },
          }}
        />
      </Box>
    </Paper>
  );
};
